(function () {
  var bars = document.querySelectorAll('[data-sticky-atc]');
  if (!bars.length) return;

  var mainProduct = document.querySelector('.oddit-section-main-product');
  if (!mainProduct) return;

  // Footer: prefer the Oddit footer wrappers, fall back to a generic <footer>.
  var footer =
    document.querySelector('.oddit-footer-main') ||
    document.querySelector('.oddit-footer-landing') ||
    document.querySelector('footer');

  var rafId = null;
  var lastVisible = null;

  function update() {
    rafId = null;

    var mainRect = mainProduct.getBoundingClientRect();
    var viewportH = window.innerHeight || document.documentElement.clientHeight;

    // Show once the main product section has fully scrolled above the viewport.
    var pastMainProduct = mainRect.bottom <= 0;

    // Hide once the footer enters the viewport.
    var footerVisible = false;
    if (footer) {
      var fRect = footer.getBoundingClientRect();
      footerVisible = fRect.top < viewportH;
    }

    var shouldShow = pastMainProduct && !footerVisible;
    if (shouldShow === lastVisible) return;
    lastVisible = shouldShow;

    bars.forEach(function (bar) {
      bar.classList.toggle('is-visible', shouldShow);
      bar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    });
  }

  function scheduleUpdate() {
    if (rafId !== null) return;
    rafId = window.requestAnimationFrame(update);
  }

  window.addEventListener('scroll', scheduleUpdate, { passive: true });
  window.addEventListener('resize', scheduleUpdate, { passive: true });
  window.addEventListener('orientationchange', scheduleUpdate, { passive: true });
  update();

  bars.forEach(function (bar) {
    var btn = bar.querySelector('[data-sticky-atc-button]');
    if (!btn) return;

    btn.addEventListener('click', function (e) {
      e.preventDefault();

      var selector = bar.getAttribute('data-scroll-target') || '#step-2';
      var target = document.querySelector(selector);
      if (!target) return;

      var rect = target.getBoundingClientRect();
      var top = rect.top + window.pageYOffset - 16;
      if (top < 0) top = 0;

      var reduceMotion =
        window.matchMedia &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      window.scrollTo({
        top: top,
        behavior: reduceMotion ? 'auto' : 'smooth',
      });
    });
  });
})();
